import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    sliderWrap: {
      overflowX: "hidden",
      padding: "38px 34px 48px",
      position: "relative",
      borderBottom: `1px solid ${primary.light}`
    },
    subTitle: {
      display: "flex",
      alignItems: "center",
      color: primary.dark,
      height: 56,
      margin: "0 22px",
      paddingTop: 8
    },
    root: {
      color: secondary.dark,
      height: 3,
      padding: "13px 0",
      "&.MuiCollapse-wrapper": {
        display: "block",
        width: 593
      }
    },
    thumb: {
      height: 27,
      width: 27,
      backgroundColor: "#fff",
      border: "1px solid currentColor",
      marginTop: -12,
      marginLeft: -13,
      boxShadow: "#ebebeb 0 2px 2px",
      "&:focus, &:hover, &$active": {
        boxShadow: "#ccc 0 2px 3px 1px"
      },
      "& .bar": {
        height: 9,
        width: 1,
        backgroundColor: "currentColor",
        marginLeft: 1,
        marginRight: 1
      }
    },
    track: {
      height: 5
    },
    rail: {
      color: primary.dark,
      opacity: 1,
      height: 3,
      width: "104%",
      left: "-2%"
    },
    active: {
      backgroundColor: "#fff"
    },
    label: {
      fontFamily: "SuisseIntlRegular",
      position: "absolute",
      bottom: 23,
      fontSize: 12,
      lineHeight: "20px",
      color: primary.dark
    },
    start: {
      left: 24
    },
    end: {
      right: 24
    },
    tooltip: {
      fontSize: 12,
      textAlign: "center",
      minWidth: 32,
      height: 21,
      backgroundColor: "#fff",
      margin: "8px 0",
      color: "#333",
      boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)"
    }
  };
});
